const {databaseServer} = require("../config/network");

const getCollections = (token) => {
    return fetch(`${databaseServer}/collections`, {
        headers: new Headers({
            'Authorization': token
        })
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const getCollectionById = (id, token) => {
    return fetch(`${databaseServer}/collections/${id}`, {
        headers: new Headers({
            'Authorization': token
        })
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const deleteCollection = (id, token) => {
    return fetch(`${databaseServer}/collections/delete/${id}`, {
        headers: new Headers({
            'Authorization': token
        })
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const updateCollection = (token,collection) => {
    return fetch(`${databaseServer}/collections/update`, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify(collection),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

const scanComplete = (token,collection) => {
    return fetch(`${databaseServer}/collections/scan_complete`, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify(collection),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));



}


const createCollection = (token, collection) => {
    return fetch(`${databaseServer}/collections`, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify(collection),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        }),
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

// P1-4: the import route now returns a real 400 when it rejects a duplicate-serial list,
// instead of 200 with an error body. A 400 carrying JSON is fine for `response.json()`, so
// the rejection itself surfaces either way — but the other failure modes that just became
// reachable are not. A 500 whose body is Express's HTML error page makes .json() throw, the
// old .catch() logged it and returned `undefined`, and `setSnackbar(undefined)` renders an
// empty toast: the operator sees a blank box and cannot tell whether the import happened.
//
// So this one helper always resolves to something with a `status` and a `message`.
// Deliberately scoped to this helper: normalising all eight fetch helpers in this file is
// worth doing, but not as part of this change.
const uploadAssetsForCollection = async (token, collectionId, assets) => {
    try {
        const response = await fetch(`${databaseServer}/collections/${collectionId}/assetList`, {
            method: 'post',
            mode: 'cors',
            body: JSON.stringify(assets),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': token
            }),
        });

        const body = await response.json().catch(() => null);

        // The data layer's own shape, success or rejection alike.
        if (body != null && body.status != null) {
            return body;
        }

        return {
            status: 'error',
            message: `Oh Snap! The import failed (server returned ${response.status}). Nothing was changed.`
        };
    } catch (error) {
        console.log(error);
        return {
            status: 'error',
            message: 'Oh Snap! Could not reach the server. The import was not started.'
        };
    }
}

module.exports = {
    getCollections,
    getCollectionById,
    createCollection,
    uploadAssetsForCollection,
    deleteCollection,
    updateCollection,
    scanComplete
}